var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cpt-chat-switch-button flex-center h-[30px] p-[2px] w-[200px] relative rounded-[5px] bg-op-1",class:[{'big': _vm.size === 'big'}, {'has-devider': _vm.devider}]},[(_vm.activeIndex > -1)?_c('div',{staticClass:"choose-slider h-[26px] rounded-[3px] bg-bd-fl absolute left-[2px] top-[2px] pointer-events-none",style:({
      width: _vm.sliderWidth,
      transform: `translateX(${_vm.activeIndex * 100}%)`,
    })}):_vm._e(),_vm._l((_vm.options),function(item){return _c('div',{key:item.value,staticClass:"option-btn flex-center",class:{
      active: _vm.value === item.value
    },on:{"click":function($event){_vm.value !== item.value && _vm.$emit('change', item.value)}}},[_vm._v(" "+_vm._s(item.label)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }